import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { PrincipalLayouts } from '../../../../layouts'
import { fetchData } from '../../../helpers/getData/fetchData'
import { AddForm } from './AddForm'

export const AddEventRegistered = () => {

    const { t } = useTranslation('global')
    const [userList, setUserList] = useState('isLoading');
    const [userRegisteredList, setUserRegisteredList] = useState('isLoading');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    useEffect(() => {
        fetchData(setUserList, '/user/getListNameAndId?type=Admin', t)
        fetchData(setUserRegisteredList, `/eventRegister/listRegistered?eventId=${searchParams.get('event')}`, t)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t])

    return (
        <PrincipalLayouts>
            {
                (userList !== 'isLoading' && userRegisteredList !== 'isLoading') &&
                <AddForm
                    userList={userList}
                    userRegisteredList={userRegisteredList.map(list => list.individualId)}
                />
            }
        </PrincipalLayouts>
    )
}
